import dynamic from "next/dynamic";
import { ThemeSwitchSkeleton } from "./ThemeSwitchSkeleton";

interface DynamicThemeSwitchProps {
  className?: string;
}

const ThemeSwitch = dynamic(
  () =>
    import("./ThemeSwitch").then((mod) => ({
      default: mod.ThemeSwitch,
    })),
  {
    loading: () => <ThemeSwitchSkeleton />,
    ssr: false,
  }
);

export function DynamicThemeSwitch({ className }: DynamicThemeSwitchProps) {
  return <ThemeSwitch className={className} />;
}
